const e = /^[0-9]+$/g;
export {
  e as RegexWholeNumber
};
//# sourceMappingURL=regex.js.map
